import { useEffect } from 'react'

/**
 * Closes a controlled dropdown when its options are no longer available.
 * Used when filter data changes while a LuxKit DropdownList may still be open.
 */
export function useCloseDropdownWhenUnavailable(
  hasOptions: boolean,
  setOpen: (open: boolean) => void,
): void {
  useEffect(() => {
    if (!hasOptions) {
      setOpen(false)
    }
  }, [hasOptions, setOpen])
}
